import {
  API_ROUTES,
  type AskRequest,
  askResponseSchema,
  type DismissPulseRequest,
  type PulseQuery,
  pulseSchema,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

/** Pulse queries. */

export const pulseKeys = {
  all: (organizationId: string) => ['pulse', organizationId] as const,
} as const;

export const pulseQuery = (organizationId: string, query: PulseQuery = {}) =>
  queryOptions({
    queryKey: ['pulse', organizationId, query] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: `${API_ROUTES.pulse.current(organizationId)}${
          query.limit === undefined ? '' : `?limit=${query.limit}`
        }`,
        schema: pulseSchema,
        signal,
      }),
    // A briefing that changes while somebody reads it is worse than one a
    // minute out of date.
    staleTime: 60_000,
  });

export async function dismissPulseSignal(organizationId: string, body: DismissPulseRequest) {
  await apiClient.request({
    method: 'POST',
    path: API_ROUTES.pulse.dismiss(organizationId),
    schema: z.undefined(),
    body,
  });
}

export async function askQuestion(organizationId: string, body: AskRequest) {
  return apiClient.request({
    method: 'POST',
    path: API_ROUTES.pulse.ask(organizationId),
    schema: askResponseSchema,
    body,
  });
}
